/**
 * Formats a review date with the existing locale string used on review cards.
 * @param {Date | string | number | undefined | null} date
 * @returns {string}
 */
export function formatReviewCardDate(date) {
  if (!date) {
    return 'Unknown Date';
  }
  try {
    return new Date(date).toLocaleString();
  } catch {
    return 'Invalid Date';
  }
}

/**
 * A local date, or null when the value is missing or cannot be parsed.
 * @param {Date | string | number | undefined | null} value
 * @returns {Date | null}
 */
function parseCalendarDate(value) {
  if (value == null || value === '') {
    return null;
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  return parsed;
}

/**
 * True when both dates fall on the same local calendar day.
 * @param {Date} left
 * @param {Date} right
 * @returns {boolean}
 */
function isSameCalendarDay(left, right) {
  return left.getFullYear() === right.getFullYear()
    && left.getMonth() === right.getMonth()
    && left.getDate() === right.getDate();
}

/**
 * Posted day, or experience day plus Posted when those calendar days differ.
 * Edited is appended when editedAt is present.
 * @param {Date | string | number | undefined | null} date
 * @param {Date | string | number | undefined | null} editedAt
 * @param {Date | string | number | undefined | null} experienceDate
 * @returns {string}
 */
export function formatReviewDateLine(date, editedAt, experienceDate) {
  const posted = parseCalendarDate(date);
  const experience = parseCalendarDate(experienceDate);
  const showExperience = posted != null
    && experience != null
    && !isSameCalendarDay(experience, posted);
  const original = showExperience
    ? `${formatReviewCardDate(experienceDate)} · Posted ${formatReviewCardDate(date)}`
    : formatReviewCardDate(date);
  if (!editedAt) {
    return original;
  }
  return `${original} · Edited ${formatReviewCardDate(editedAt)}`;
}
